export const entryScreenContent = {
  header: 'Please complete the following',
  header_desc:
    'All personal information provided through this secure form will remain confidential and will not be shared without your legal authorization.',
  reason_for_visit: 'Reason for visit',
  medical_history: 'Medical History',
  pharmacy_medications: 'Pharmacy & Medications',
  acknowledge_sign: 'Acknowledge & Sign',
  acknowledge_sign_desc: 'How we protect your privacy',
};
